import Vue from 'vue';
import Router from 'vue-router';
import appMain from '@/components/appMain';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/*',
      name: 'appMain',
      component: appMain,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js